import { useEffect, useState } from "react";

const Clock = () => {
    const [time, setTime] = useState<string>("");

    useEffect(() => {
        const update = () => {
            setTime(
                new Date().toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                }),
            );
        };
        update();
        const intervalId = setInterval(update, 1000);

        return () => clearInterval(intervalId);
    }, []);

    if (!time) return null; // avoid SSR mismatch entirely

    return (
        <div className="text-center">
            <p className="mt-4 font-mono text-lg">{time}</p>
        </div>
    );
};

export default Clock;
